import { compose, createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

import createLogger from "./middlewares/logger";

import reducer from "./reducer";

const actionsToSkipLogging: string[] = [
  // Add action to skip logging
  "auth/SET_AUTH",
];

// Override compose if development mode and redux extension is installed
const isDevelopmentMode = import.meta.env.VITE_NODE_ENV === "DEVELOPMENT";
const middleware = isDevelopmentMode
  ? [createLogger(actionsToSkipLogging)]
  : [];
const overrideCompose = !!composeWithDevTools && isDevelopmentMode;

const applicableCompose = !overrideCompose
  ? compose
  : composeWithDevTools({
      actionsBlacklist: actionsToSkipLogging,
    });

const enhancer = applicableCompose(applyMiddleware(...middleware));

const store = createStore(reducer, undefined, enhancer);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
